import { createSlice } from '@reduxjs/toolkit';
import { getStlifeImagesById } from '../thunks/studentLifeThunk';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

const studentLifeImages = createSlice({
  name: 'stlifeimages',
  initialState,
  reducers: {
    setData(state, action) {
      state.list = action.payload.data;
      state.total = action.payload.total;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStlifeImagesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStlifeImagesById.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(getStlifeImagesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setData } = studentLifeImages.actions;
export default studentLifeImages.reducer;